var O;!function(O){O.TOP="TOP",O.BOTTOM="BOTTOM"}(O||(O={}));export{O as PAGE_TITLE_POS};
